import React from "react";
// import dayjs from "dayjs";
import { Select } from "antd";
import dayjs from "dayjs";
import { TENTATIVE_TIME_VALUE } from "../../library/constants";

const duration = require("dayjs/plugin/duration");

dayjs.extend(duration);

const { Option } = Select;

const isEarlierThanEndLimit = (timeValue, endLimit, lastValue, defaultDate) => {
  const start = dayjs(defaultDate).add(dayjs.duration(timeValue));
  const timeValueIsEarlier = dayjs(timeValue, "hh:mm A") <= dayjs(endLimit, "hh:mm A");

  const timeValueIsLaterThanLastValue =
    lastValue === undefined ? true : dayjs(lastValue, "hh:mm A") < dayjs(timeValue, "hh:mm A");

  return timeValueIsEarlier && timeValueIsLaterThanLastValue;
};

const renderOptions = (
  startTime,
  endTime,
  minuteStep,
  disabledTimes,
  defaultDate,
  showTentative
) => {
  const tentativeOption = showTentative ? (
    <Option key="key__tentative" value={TENTATIVE_TIME_VALUE}>
      {TENTATIVE_TIME_VALUE}
    </Option>
  ) : null;

  // If start or end time is not provided, only render the tentative option (when enabled)
  if (!startTime || !endTime) {
    return tentativeOption ? [tentativeOption] : [];
  }

  // Helper: consider slots "past" only when selected date is today
  const isPastTimeForSelectedDate = timeValue => {
    if (!defaultDate) return false;

    const selectedDay = dayjs(defaultDate);
    const today = dayjs();

    // Only apply past-time rule when the selected date is today
    if (!selectedDay.isSame(today, "day")) {
      return false;
    }

    const nowTime = today.format("HH:mm");
    const slotTime = dayjs(timeValue, "h:mm A").format("HH:mm");
    return nowTime >= slotTime;
  };

  let timeValue = startTime;
  const endLimit = endTime;
  const step = minuteStep || 15;
  const options = [];
  if (tentativeOption) {
    options.push(tentativeOption);
  }
  let index = 0;
  options.push(
    <Option
      key={`key__${index}`}
      value={timeValue}
      disabled={disabledTimes?.includes(timeValue) || isPastTimeForSelectedDate(timeValue)}
    >
      {timeValue}
    </Option>
  );

  while (true) {
    const nextTime = dayjs(timeValue, "h:mm A").add(step, "minutes").format("h:mm A");

    // Only add the next slot if it is still within the endLimit
    if (!isEarlierThanEndLimit(nextTime, endLimit, timeValue, defaultDate)) {
      break;
    }

    timeValue = nextTime;
    index += 1;
    options.push(
      <Option
        key={`key__${index}`}
        value={timeValue}
        disabled={disabledTimes.includes(timeValue) || isPastTimeForSelectedDate(timeValue)}
      >
        {timeValue}
      </Option>
    );
  }
  return options;
};

const CustomTimePicker = ({
  fkey,
  value = null,
  onChange,
  startTime,
  endTime,
  minuteStep = 15,
  placeholder = "Select time",
  disabledTimes = [],
  disabled = false,
  defaultDate = dayjs(),
  getPopupContainer,
  showTentative = false,
}) => {
  return (
    <div className="flex-1" key="div__fkey">
      <Select
        className="w-full"
        key={fkey}
        value={value || undefined}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        getPopupContainer={getPopupContainer}
      >
        {renderOptions(startTime, endTime, minuteStep, disabledTimes, defaultDate, showTentative)}
      </Select>
    </div>
  );
};

export default CustomTimePicker;
